import data from "../data.json";

/**
 * Loads all quiz data from JSON file
 * @returns {Array</Object>} Array of quiz objects with questions
 */
export const loadQuizData = () => {
  return data.quizzes;
};

/**
 * Retrieves a specific quiz by its title
 * @param {string} title - The title of the quiz(e.g. 'HTML')
 * @returns {Object|undefined} The quiz object or undefined if not found
 */
export const getQuizByTitle = (title) => {
  return data.quizzes.find((quiz) => quiz.title === title);
};
